const propertyOptions = [
	'Active Consents',
	'Pending Consent Requests',
	'Rejected Consents',
	'Revoked Consents',
	'Customers Onboarded',
];
export default propertyOptions;
